import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Flex, Text, Avatar, VStack } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { formatTimestamp } from './config-helpers';
const ConfigChange = ({ change, userDetails })=>{
    const formattedDate = formatTimestamp(change.createdDate);
    const getInitials = ()=>{
        if (!userDetails?.firstName && !userDetails?.lastName) {
            return '?';
        }
        const firstInitial = userDetails.firstName ? userDetails.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = userDetails.lastName ? userDetails.lastName.charAt(0).toUpperCase() : '';
        return `${firstInitial}${lastInitial}` || '?';
    };
    const getChangedByText = ()=>{
        if (!userDetails) {
            return 'No user information available';
        }
        const fullName = `${userDetails.firstName || ''} ${userDetails.lastName || ''}`.trim();
        const username = userDetails.username;
        if (fullName && username) {
            return `Changed by: ${fullName} ${username}`;
        } else if (fullName) {
            return `Changed by: ${fullName}`;
        } else if (username) {
            return `Changed by: ${username}`;
        } else {
            return 'No user information available';
        }
    };
    const initials = getInitials();
    return /*#__PURE__*/ _jsx(Flex, {
        borderWidth: "1px",
        borderRadius: "lg",
        p: 4,
        shadow: "sm",
        align: "start",
        gap: 4,
        wrap: "wrap",
        children: /*#__PURE__*/ _jsxs(VStack, {
            align: "start",
            spacing: 1,
            flex: "1",
            children: [
                /*#__PURE__*/ _jsxs(Flex, {
                    direction: "row",
                    align: "center",
                    gap: 3,
                    children: [
                        /*#__PURE__*/ _jsx(Avatar, {
                            size: "sm",
                            bg: "gray.200",
                            name: initials,
                            color: "black"
                        }),
                        /*#__PURE__*/ _jsxs(Flex, {
                            align: "center",
                            mt: 2,
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    fontSize: "sm",
                                    children: change.configurationPreviousValue
                                }),
                                /*#__PURE__*/ _jsx(ArrowForwardIcon, {
                                    mx: 2
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    fontSize: "sm",
                                    children: change.configurationCurrentValue
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fontSize: "sm",
                    color: "gray.600",
                    children: getChangedByText()
                }),
                /*#__PURE__*/ _jsxs(Text, {
                    fontSize: "sm",
                    children: [
                        "Keyname: ",
                        change.keyname
                    ]
                }),
                /*#__PURE__*/ _jsxs(Text, {
                    fontSize: "sm",
                    children: [
                        "Section: ",
                        change.section
                    ]
                }),
                /*#__PURE__*/ _jsxs(Text, {
                    fontSize: "sm",
                    children: [
                        "Service line: ",
                        change.serviceLineName === 'Inpatient Professional Coding' ? 'Bedside Pro' : change.serviceLineName || 'Global'
                    ]
                }),
                change.jiratTicket && /*#__PURE__*/ _jsxs(Text, {
                    fontSize: "sm",
                    children: [
                        "JIRA Ticket #: ",
                        change.jiratTicket
                    ]
                }),
                change.jiraPurpose && /*#__PURE__*/ _jsxs(Text, {
                    fontSize: "sm",
                    children: [
                        "Description: ",
                        change.jiraPurpose
                    ]
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fontSize: "sm",
                    color: "gray.500",
                    children: formattedDate
                })
            ]
        })
    });
};
export default ConfigChange;
